import { useGetMe } from '@/hooks/shared/useGetMe';
import { logoutUser } from '@/store/services/userServices';
import { Header } from '@/containers/Header';
import { Footer } from '@/components/Footer';
import './index.scss';

export const BasicLayout = ({ children }) => {
  const { user } = useGetMe();

  return (
    <div className="basic-layout">
      <Header user={user} logout={logoutUser} />
      <main>{children}</main>
      <Footer />
    </div>
  );
};
